import React from 'react';
import { Button } from '../../ui/button';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '../../ui/dialog';

import { CommonHeader } from './formSections/CommonHeader';
import { PlywoodBulkSection } from './formSections/PlywoodBulkSection';
import { AdhesivesBulkSection } from './formSections/AdhesivesBulkSection';
import { SingleProductSection } from './formSections/SingleProductSection';

/**
 * ProductFormDialog — thin orchestrator (R2 phase 2 refactor).
 *
 * Owns nothing but the top-level layout, the dialog title, the Save button,
 * and which of the three mode-specific sections to render. All state comes
 * from the parent (ProductManagement) via props so the form-mode toggles
 * (`isPlywoodBulkMode`, `isWeightBulkCategory`) stay authoritative in one
 * place and never drift.
 */
export function ProductFormDialog(props) {
  const {
    editingGroup,
    editingProduct,
    form,
    isPlywoodBulkMode,
    isWeightBulkCategory,
    saving,
    setEditingGroup,
    setShowDialog,
    showDialog,
    handleSave,
  } = props;

  const wide = isPlywoodBulkMode || isWeightBulkCategory;
  const title = editingGroup
    ? `Edit ${form.brand_name} ${form.subcategory} ${form.grade}`
    : editingProduct
      ? 'Edit Product'
      : (isPlywoodBulkMode ? `Add ${form.main_category} Product (All Thicknesses)` : 'Add Product');

  return (
    <Dialog open={showDialog} onOpenChange={(open) => { setShowDialog(open); if (!open) setEditingGroup(null); }}>
      <DialogContent className={`${wide ? 'max-w-2xl' : 'max-w-lg'} max-h-[90vh] overflow-y-auto`} data-testid="product-form-dialog">
        <DialogHeader>
          <DialogTitle>{title}</DialogTitle>
        </DialogHeader>
        <div className="space-y-3">
          <CommonHeader {...props} />

          {isPlywoodBulkMode && <PlywoodBulkSection {...props} />}

          {isWeightBulkCategory && <AdhesivesBulkSection {...props} />}

          {!isPlywoodBulkMode && !isWeightBulkCategory && (
            <SingleProductSection {...props} />
          )}

          <Button onClick={handleSave} disabled={saving} className="rounded-xl bg-heda-ink text-white shadow-none hover:bg-black w-full" data-testid="form-save-btn">
            {saving ? 'Saving...' : (editingProduct ? 'Update Product' : (isPlywoodBulkMode ? 'Add All Products' : 'Add Product'))}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
